
export type CustomerAngularEditorComponentValue = string | null;
